import React, { useRef, useState } from "react";
import {
  Typography,
  Button,
  Grid,
  Box,
  Divider,
} from "@mui/material";
import { styled } from "@mui/system";
import emailjs from "@emailjs/browser";
import { useLocation } from "react-router-dom";
import Map from "./Map";

const black = {
  500: "#010203",
  600: "#121212",
  700: "#232323",
};

const CustomButton = styled(Button)`
  font-family: IBM Plex Sans, sans-serif;
  font-weight: bold;
  font-size: 0.875rem;
  background-color: ${black[500]};
  padding: 12px 24px;
  border-radius: 12px;
  color: white;
  transition: all 150ms ease;
  cursor: pointer;

  &:hover {
    background-color: ${black[600]};
  }

  &:active {
    background-color: ${black[700]};
  }

  &:focus-visible {
    box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1),
      0 0 0 5px rgba(0, 127, 255, 0.5);
    outline: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

function Contact() {
  const form = useRef();
  const [reason, setReason] = useState("Product Information");
  const location = useLocation();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_kzox1xm",
        "template_vxb5zct",
        form.current,
        "y14FG06q_anoleWO0"
      )
      .then(
        (result) => {
          console.log(result.text);
          form.current.reset();
          setReason("");
          alert("Message sent successfully!");
        },
        (error) => {
          console.log(error.text);
          alert("Failed to send message.");
        }
      );
  };

  return (
    <Box className="contact" sx={{ p: { xs: 2, md: 5 } }}>
      <Grid
        container
        spacing={4}
        justifyContent="center"
        alignItems="stretch"
      >
        {/* Address Section */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              color: "#fff",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              p: { xs: 3, md: 4 },
              borderRadius: 4,
              height: "100%",
            }}
          >
            <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold" }}>
              WE ARE HERE FOR YOU.
            </Typography>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
              JUHU TARA ROAD, NEXT TO HOTEL SEA PRINCESS,<br /> AIRPORT AREA,
              JUHU MUMBAI,<br /> MAHARASHTRA 400049
            </Typography>
            <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
              <a
                href="https://wa.me/919833097025"
                style={{ color: "#fff", textDecoration: "none" }}
              >
                Contact Number: 9833097025
              </a>
            </Typography>
          </Box>
        </Grid>

        {/* Divider for desktop only */}
        <Grid
          item
          md="auto"
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "stretch",
          }}
        >
          <Divider
            orientation="vertical"
            flexItem
            sx={{ backgroundColor: "rgba(255,255,255,0.3)" }}
          />
        </Grid>

        {/* Map Section */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              p: 2,
              borderRadius: 4,
              height: "100%",
            }}
          >
            <Map height={420} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Contact;
